import React, { createContext, ReactNode, useContext } from "react";
import {
  adminpayload,
  createupdateDeportmentModel,
  createupdateRoleModel,
  createupdateUserModel,
  DepartmentResponse,
  getRoleModel,
  usergetpayload,
  userListModel,
} from "../model/adminModel";
import useAdminApi from "../api/admin";
import { useNavigate } from "react-router-dom";

interface AdminContextType {
  listUser: userListModel[] | null;
  userDetail: userListModel | null;
  listRole: getRoleModel[] | null;
  roleDetail: getRoleModel | null;
  listDepartment: DepartmentResponse[] | null;
  departmentDetail: DepartmentResponse | null;
  getAllUser: (item: usergetpayload) => void;
  getUserBYID: (item: number) => void;
  getUserupdate: (userid: number, item: createupdateUserModel) => void;
  getUserCreate: (item: createupdateUserModel) => void;
  deleteUserByID: (item: number) => void;
  getAllRole: (item: adminpayload) => void;
  getRoleBYID: (item: number) => void;
  getRoleupdate: (roleId: number, item: createupdateRoleModel) => void;
  getRoleCreate: (item: createupdateRoleModel) => void;
  deleteRoleByID: (item: number) => void;
  getAllDepartment: (item: adminpayload) => void;
  getDepartmentBYID: (item: number) => void;
  getDepartmentCreate: (item: createupdateDeportmentModel) => void;
  getDepartmentupdate: (roleId: number, item: createupdateDeportmentModel) => void;
  deleteDepartmentByID: (item: number) => void;
  setListUser: (item: userListModel[] | null) => void;
}

const defaultAdminContext: AdminContextType = {
  listUser: null,
  userDetail: null,
  listRole: null,
  roleDetail: null,
  listDepartment: null,
  departmentDetail: null,
  getAllUser: () => {},
  getUserBYID: () => {},
  getUserupdate: () => {},
  getUserCreate: () => {},
  deleteUserByID: () => {},
  getAllRole: () => {},
  getRoleBYID: () => {},
  getRoleupdate: () => {},
  getRoleCreate: () => {},
  deleteRoleByID: () => {},
  getAllDepartment: () => {},
  getDepartmentBYID: () => {},
  getDepartmentCreate: () => {},
  getDepartmentupdate: () => {},
  deleteDepartmentByID: () => {},
  setListUser: () => {}
};

const AdminContext = createContext<AdminContextType>(defaultAdminContext);

export const AdminProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const navigator = useNavigate();
  const [listUser, setListUser] = React.useState<userListModel[] | null>(null);
  const [userDetail, setUserDetail] = React.useState<userListModel | null>(null);
  const [listRole, setListRole] = React.useState<getRoleModel[] | null>(null);
  const [roleDetail, setRoleDetail] = React.useState<getRoleModel | null>(null);
  const [listDepartment, setListDepartment] = React.useState<DepartmentResponse[] | null>(null);
  const [departmentDetail, setDepartmentDetail] = React.useState<DepartmentResponse | null>(null);

  const {
    fetchGetUser,
    fetchGetUserByID,
    fetchCreateUser,
    fetchUpdateUserByID,
    fetchDeleteUserByID,
    fetchGetRole,
    fetchGetRoleByID,
    fetchCreateRole,
    fetchUpdateRoleByID,
    fetchDeleteRoleByID,
    fetchGetDepartment,
    fetchGetDepartmentByID,
    fetchCreateDepartment,
    fetchUpdateDepartmentByID,
    fetchDeleteDepartmentByID,
  } = useAdminApi();

  const getAllUser = React.useCallback(
    async (payload: usergetpayload) => {
      try {
        const responseData = await fetchGetUser(payload.search);
        setListUser(responseData);
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchGetUser],
  );

  const getUserBYID = React.useCallback(async (userID: number) => {
    try {
      const responseData = await fetchGetUserByID(userID);
      setUserDetail(responseData);
      return responseData;
    } catch (error) {
      // setError(error.message);
    }
  }, []);

  const getUserupdate = React.useCallback(
    async (userID: number, payload: createupdateUserModel) => {
      try {
        const responseData = await fetchUpdateUserByID(userID, payload);
        if (responseData) {
          navigator(-1);
        }
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchUpdateUserByID],
  );

  const getUserCreate = React.useCallback(
    async (payload: createupdateUserModel) => {
      try {
        const responseData = await fetchCreateUser(payload);
        if (responseData) {
          navigator(-1);
        }
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchCreateUser],
  );

  const deleteUserByID = React.useCallback(
    async (userId: number) => {
      try {
        const responseData = await fetchDeleteUserByID(userId);
        if (responseData) {
          navigator(-1);
        }
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchDeleteUserByID],
  );

  const getAllRole = React.useCallback(
    async (payload: adminpayload) => {
      try {
        const responseData = await fetchGetRole(payload.skip, payload.limit);
        setListRole(responseData);
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchGetRole],
  );

  const getRoleBYID = React.useCallback(
    async (userID: number) => {
      try {
        const responseData = await fetchGetRoleByID(userID);
        setRoleDetail(responseData);
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchGetRoleByID],
  );

  const getRoleupdate = React.useCallback(
    async (roleID: number, payload: createupdateRoleModel) => {
      try {
        const responseData = await fetchUpdateRoleByID(roleID, payload);
        if(responseData){
          const payloads = {
            skip: 0,
            limit: 50,
          };
          getAllRole(payloads)
        }
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchUpdateRoleByID],
  );

  const getRoleCreate = React.useCallback(
    async (payload: createupdateRoleModel) => {
      try {
        const responseData = await fetchCreateRole(payload);
        if(responseData){
          const payloads = {
            skip: 0,
            limit: 50,
          };
          getAllRole(payloads)
        }
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchCreateRole],
  );

  const deleteRoleByID = React.useCallback(
    async (roleId: number) => {
      try {
        const responseData = await fetchDeleteRoleByID(roleId);
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchDeleteRoleByID],
  );

  const getAllDepartment = React.useCallback(
    async (payload: adminpayload) => {
      try {
        const responseData = await fetchGetDepartment(payload.skip, payload.limit);
        setListDepartment(responseData);
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchGetDepartment],
  );

  const getDepartmentBYID = React.useCallback(
    async (userID: number) => {
      try {
        const responseData = await fetchGetDepartmentByID(userID);
        setDepartmentDetail(responseData);
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchGetDepartmentByID],
  );

  const getDepartmentupdate = React.useCallback(
    async (roleID: number, payload: createupdateDeportmentModel) => {
      try {
        const responseData = await fetchUpdateDepartmentByID(roleID, payload);
        if(responseData){
          const payloads = {
            skip: 0,
            limit: 100,
          };
          getAllDepartment(payloads)
        }
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchUpdateDepartmentByID],
  );

  const getDepartmentCreate = React.useCallback(
    async (payload: createupdateDeportmentModel) => {
      try {
        const responseData = await fetchCreateDepartment(payload);
        if(responseData){
          const payloads = {
            skip: 0,
            limit: 100,
          };
          getAllDepartment(payloads)
        }
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchCreateDepartment],
  );

  const deleteDepartmentByID = React.useCallback(
    async (roleId: number) => {
      try {
        const responseData = await fetchDeleteDepartmentByID(roleId);
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchDeleteDepartmentByID],
  );

  return (
    <AdminContext.Provider
      value={{
        listUser,
        userDetail,
        listRole,
        roleDetail,
        listDepartment,
        departmentDetail,
        getAllUser,
        getUserBYID,
        getUserupdate,
        getUserCreate,
        deleteUserByID,
        getAllRole,
        getRoleBYID,
        getRoleupdate,
        getRoleCreate,
        deleteRoleByID,
        getAllDepartment,
        getDepartmentBYID,
        getDepartmentCreate,
        getDepartmentupdate,
        deleteDepartmentByID,
        setListUser
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export const useAdminContext = () => useContext(AdminContext);

export { AdminContext };
